module.exports = __webpack_public_path__ + "static/img/banner4.9a76939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner4.jpg
// module id = dc4U
// module chunks = 1